import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from "@angular/core";
import { RequestStatusEnum } from "../../../shared/services/request-status.service";

@Component({
  selector: 'app-request-action-toolbar-button',
  templateUrl: './request-action-toolbar-button.component.html'
})
export class RequestActionToolbarButtonComponent implements OnChanges {
    @Input() visibilityStatuses: RequestStatusEnum[];
    @Input() requestStatus: RequestStatusEnum;
    @Input() buttonLabel: string;

    @Output() onButtonClicked: EventEmitter<any> = new EventEmitter();

    public showButton: boolean = false;

    constructor() { }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.visibilityStatuses || !this.requestStatus) {
            this.showButton = true;
            return;
        }

        if (this.visibilityStatuses.includes(this.requestStatus)) {
            this.showButton = true;
        } else {
            this.showButton = false;
        }
    }

    public buttonClicked(): void {
        this.onButtonClicked.emit(null);
    }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-action-toolbar/request-action-toolbar-button/request-action-toolbar-button.component.ts